import React from "react";
import { CvParsingButton } from "qjumpers.common.ui";
import { useSetRecoilState } from "recoil";
import { cvParsingResponse } from "../../recoil/cvparsing/atom";
import { errorState } from "../../recoil/error/atom";
import { parseCv } from "../../requests/cvparsing";

export const CvParsingButtonWrapper = (props) => {
  const { formData, multiple, onChange, uiSchema } = props;
  const setCvParsingResponseData = useSetRecoilState(cvParsingResponse);
  const popError = useSetRecoilState(errorState);

  return (
    <CvParsingButton
      formData={formData}
      multiple={multiple}
      onChange={onChange}
      parseCv={parseCv}
      popError={popError}
      setCvParsingResponseData={setCvParsingResponseData}
      uiSchema={uiSchema}
    />
  );
};
